import React from "react";
import { Row, Col, Button } from "antd";
import "./index.css";
// import ConnectWithStripe from "../../assets/images/strip-new.png"
import StripeIcon from "../../assets/images/stripe-icon.jpg";

const ConnectToStripe = ({ companyDetails }) => {
  console.log("stripe_connect", companyDetails?.rmx_company_asset?.store_url);
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginTop: "20px" }}
        >
          <Col>
            <span style={{ fontWeight: "bolder" }}>Stripe Account Status</span>
          </Col>
          <Col>
            <span
              className="st-stipe-btn  pointer-cursor"
              onClick={() => {
                companyDetails?.stripe_account_connected == 0 &&
                  // window.open(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_9vHCPAOGVa8sUdJcpk7JAQGTjuIel8Md&scope=read_write&state=${companyDetails?.rmx_company_asset?.store_url}.api-stg2.surface-tech.com/trkr_plant_web_app/dashboard`)
                  window.open(
                    `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_9vHCPAOGVa8sUdJcpk7JAQGTjuIel8Md&scope=read_write&state=${companyDetails?.rmx_company_asset?.store_url}${process.env.REACT_APP_DOMAIN}&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}`
                  );
              }}
            >
              <span>
                <img src={StripeIcon} />
              </span>
              <span className="st-stipe-link">
                {companyDetails?.stripe_account_connected == 0
                  ? "Connect with Stripe"
                  : "Connected with Stripe"}
              </span>
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default ConnectToStripe;
